import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import Skeleton from "@mui/material/Skeleton";
import Grid from "@mui/material/Grid";
import { Slide } from "react-slideshow-image";
import "react-slideshow-image/dist/styles.css";
import ProductCard from "CommonComponents/ProductCard/ProductCard.jsx";

const responsiveSettings = [
  { breakpoint: 1900, settings: { slidesToShow: 6, slidesToScroll: 1 } },
  { breakpoint: 1200, settings: { slidesToShow: 5, slidesToScroll: 1 } },
  { breakpoint: 800, settings: { slidesToShow: 4, slidesToScroll: 1 } },
  { breakpoint: 500, settings: { slidesToShow: 3, slidesToScroll: 1 } },
  { breakpoint: 0, settings: { slidesToShow: 2, slidesToScroll: 1 } },
];

export default function AdditionalProducts({
  products,
  loading,
  headerRefresh,
  setHeaderRefresh,
}) {
  const renderSkeletonSlider = () => (
    <Grid container spacing={2}>
      {[...Array(5)].map((_, index) => (
        <Grid item xs={4} sm={3} md={2.4} lg={2} xl={2} key={index}>
          <Box sx={{ width: "100%", p: 1 }}>
            <Skeleton
              variant="rectangular"
              width="100%"
              height={200}
              animation="wave"
              sx={{ borderRadius: "8px" }}
            />
            <Box sx={{ pt: 1 }}>
              <Skeleton animation="wave" height={24} width="70%" />
              <Skeleton animation="wave" height={20} width="50%" />
              <Box
                sx={{ display: "flex", justifyContent: "space-between", mt: 1 }}
              >
                <Skeleton animation="wave" height={24} width="40%" />
                <Box sx={{ display: "flex", gap: 1 }}>
                  <Skeleton
                    animation="wave"
                    variant="circular"
                    width={24}
                    height={24}
                  />
                  <Skeleton
                    animation="wave"
                    variant="circular"
                    width={24}
                    height={24}
                  />
                </Box>
              </Box>
            </Box>
          </Box>
        </Grid>
      ))}
    </Grid>
  );

  return (
    <Container maxWidth="xl" sx={{ py: 3 }}>
      <Typography
        variant="h4"
        align="center"
        sx={{ fontWeight: "bold", mb: 1 }}
      >
        Popular Products
      </Typography>
      <Box
        sx={{
          width: "80px",
          height: "2px",
          backgroundColor: "primary.main",
          mx: "auto",
          mb: 2,
        }}
      />

      {loading ? (
        renderSkeletonSlider()
      ) : (
        <Slide
          responsive={responsiveSettings}
          indicators={true}
          infinite={true}
        >
          {products.map((product) => (
            <Box key={product.Product_Id} sx={{ px: 1, py: 2 }}>
              <ProductCard
                product={product}
                headerRefresh={headerRefresh}
                setHeaderRefresh={setHeaderRefresh}
              />
            </Box>
          ))}
        </Slide>
      )}
    </Container>
  );
}
